import LabeledSelect from "../components/LabeledSelect";
import ButtonSave from "../components/ButtonSave";
import { UseFormSetValue, UseFormWatch } from "react-hook-form";

interface Props {
  hasUnsavedChanges: boolean;
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
}

export default function PrivacyTab({
  hasUnsavedChanges,
  watch,
  setValue,
}: Props) {
  const getLabel = (list: { value: string; label: string }[], v: string) => {
    return list?.find((o) => o.value === v)?.label || v || "";
  };

  const profileVisibility = watch("user_profile_visibility");
  const statsVisibility = watch("user_stats_visibility");
  const profileVisibilitySelected = watch("user_profile_visibility_selected");
  const statsVisibilitySelected = watch("user_stats_visibility_selected");
  return (
    <>
      <div className="cabinet_profileeditmodal-right-content">
        <div className="cabinet_profileeditmodal-right-content-text">
          <div className="cabinet_profileeditmodal-right-content-text-title">
            Конфиденциальность
          </div>
          <div className="cabinet_profileeditmodal-right-content-text-description">
            Настройте отображение информации
          </div>
        </div>
        <LabeledSelect
          label="Кто видит профиль"
          value={getLabel(profileVisibility, profileVisibilitySelected)}
          options={profileVisibility}
          setValue={setValue}
          formName="user_profile_visibility_selected"
          classes={{
            select_wrapper: "cabinet_profileeditmodal-right-content-region",
            select_option:
              "cabinet_profileeditmodal-right-content-region-option",
            select_value: "cabinet_profileeditmodal-right-content-region-value",
          }}
        />
        <LabeledSelect
          label="Кто видит статистику"
          value={getLabel(statsVisibility, statsVisibilitySelected)}
          options={statsVisibility}
          setValue={setValue}
          formName="user_stats_visibility_selected"
          classes={{
            select_wrapper: "cabinet_profileeditmodal-right-content-region",
            select_option:
              "cabinet_profileeditmodal-right-content-region-option",
            select_value: "cabinet_profileeditmodal-right-content-region-value",
          }}
        />
      </div>
      <div className={"buttonsave-privacy"}>
        <ButtonSave hasUnsavedChanges={hasUnsavedChanges} />
      </div>
    </>
  );
}
